<section id="overview" >
    <div class="container" id="overview_section">
        <h2 class="rps-heading-two" id="overview_header">Overview</h2>
        <div class="row">
            <div class="col-lg-8 col-sm-12">
                <div>
                    <key-facts [overviewModel]='overviewModel'></key-facts>
                </div>
                <div *ngIf="overviewModel?.isInternalFund">
                    <ratings [overviewModel]='overviewModel'></ratings>
                </div>
                <div>
                    <price [overviewModel]='overviewModel' [expenseRatioFootnote]='overviewModel?.expenseRatioFootnote?.footnote'></price>
                </div>
                <div *ngIf="overviewModel?.isExternalFund">
                    <div class="price-top-heading">
                        <h5 class="rps-heading-five">Fund literature</h5>
                        <p class="db-title rps-paragraph-two" >
                            <a   [attr.href]="literatureLink" class="literatureLink primary-independent" >View prospectus and reports</a>
                        </p>
                    </div>
                </div>

            </div>
            <div class="col-lg-4 col-sm-12 ppf-container">
                <div class="container">
                    <div class="row" *ngIf="overviewModel?.isInternalFund || (overviewModel?.isExternalFund && !overviewModel?.isETF)">
                        <performance class="perf-align" [overviewModel]='overviewModel'></performance>
                    </div>
                    <div>
                        <product-summary [overviewModel]='overviewModel'></product-summary>
                    </div>
                    <div>
                        <fund-management [overviewModel]='overviewModel'></fund-management>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
